/** PURE_IMPORTS_START  PURE_IMPORTS_END */
export function isScheduler(value) {
    return value && typeof value.schedule === 'function';
}
//# sourceMappingURL=isScheduler.js.map



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/internal/util/isScheduler.js
// module id = 111
// module chunks = 2